// @ts-check

import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import Currency from "./currency.js"
import Locale from "./locale.js"
import StripeTaxRate from "./stripe-tax-rate.js"

const modelClassData = {
  "attributes": {
    "country_code": {
      "column": {
        "default": null,
        "name": "country_code",
        "null": false,
        "type": "string"
      },
      "name": "country_code",
      "selected_by_default": null,
      "translated": false
    },
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": true
    },
    "default_currency_id": {
      "column": {
        "default": null,
        "name": "default_currency_id",
        "null": true,
        "type": null
      },
      "name": "default_currency_id",
      "selected_by_default": null,
      "translated": false
    },
    "default_locale_id": {
      "column": {
        "default": null,
        "name": "default_locale_id",
        "null": true,
        "type": null
      },
      "name": "default_locale_id",
      "selected_by_default": null,
      "translated": false
    },
    "first_school_date": {
      "column": {
        "default": null,
        "name": "first_school_date",
        "null": true,
        "type": "date"
      },
      "name": "first_school_date",
      "selected_by_default": null,
      "translated": false
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": true
    },
    "stripe_tax_rate_id": {
      "column": {
        "default": null,
        "name": "stripe_tax_rate_id",
        "null": true,
        "type": null
      },
      "name": "stripe_tax_rate_id",
      "selected_by_default": null,
      "translated": false
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": true
    },
    "name": {
      "column": null,
      "name": "name",
      "selected_by_default": false,
      "translated": true
    },
    "name_da": {
      "column": null,
      "name": "name_da",
      "selected_by_default": false,
      "translated": false
    },
    "name_en": {
      "column": null,
      "name": "name_en",
      "selected_by_default": false,
      "translated": false
    },
    "name_no": {
      "column": null,
      "name": "name_no",
      "selected_by_default": false,
      "translated": false
    },
    "name_se": {
      "column": null,
      "name": "name_se",
      "selected_by_default": false,
      "translated": false
    }
  },
  "className": "Country",
  "collectionKey": "countries",
  "collectionName": "countries",
  "i18nKey": "country",
  "camelizedLower": "country",
  "name": "Country",
  "nameDasherized": "country",
  "pluralName": "countries",
  "ransackable_associations": [
    {
      "className": "Country::Audit",
      "collectionName": "country_audits",
      "foreignKey": "country_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "CountryAudit",
      "through": null
    },
    {
      "className": "Contact",
      "collectionName": "contacts",
      "foreignKey": "country_id",
      "name": "contacts",
      "macro": "has_many",
      "resource_name": "Contact",
      "through": null
    },
    {
      "className": "Country::Audit",
      "collectionName": "country_audits",
      "foreignKey": "country_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "CountryAudit",
      "through": null
    },
    {
      "className": "Country::Translation",
      "collectionName": null,
      "foreignKey": "country_id",
      "name": "current_translation",
      "macro": "has_one",
      "resource_name": null,
      "through": null
    },
    {
      "className": "Currency",
      "collectionName": "currencies",
      "foreignKey": "default_currency_id",
      "name": "default_currency",
      "macro": "belongs_to",
      "resource_name": "Currency",
      "through": null
    },
    {
      "className": "Locale",
      "collectionName": "locales",
      "foreignKey": "default_locale_id",
      "name": "default_locale",
      "macro": "belongs_to",
      "resource_name": "Locale",
      "through": null
    },
    {
      "className": "School",
      "collectionName": "schools",
      "foreignKey": "contact_id",
      "name": "schools",
      "macro": "has_many",
      "resource_name": "School",
      "through": "contacts"
    },
    {
      "className": "CountryState",
      "collectionName": "country_states",
      "foreignKey": "country_id",
      "name": "states",
      "macro": "has_many",
      "resource_name": "CountryState",
      "through": null
    },
    {
      "className": "StripeTaxRate",
      "collectionName": "stripe_tax_rates",
      "foreignKey": "stripe_tax_rate_id",
      "name": "stripe_tax_rate",
      "macro": "belongs_to",
      "resource_name": "StripeTaxRate",
      "through": null
    },
    {
      "className": "Country::Translation",
      "collectionName": null,
      "foreignKey": "country_id",
      "name": "translations",
      "macro": "has_many",
      "resource_name": null,
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "country_code",
      "column": {
        "default": null,
        "name": "country_code",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "default_currency_id",
      "column": {
        "default": null,
        "name": "default_currency_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "default_locale_id",
      "column": {
        "default": null,
        "name": "default_locale_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "first_school_date",
      "column": {
        "default": null,
        "name": "first_school_date",
        "null": true,
        "type": "date"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "stripe_tax_rate_id",
      "column": {
        "default": null,
        "name": "stripe_tax_rate_id",
        "null": true,
        "type": null
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "Currency",
      "collectionName": "currencies",
      "foreignKey": "default_currency_id",
      "name": "default_currency",
      "macro": "belongs_to",
      "resource_name": "Currency",
      "through": null
    },
    {
      "className": "Locale",
      "collectionName": "locales",
      "foreignKey": "default_locale_id",
      "name": "default_locale",
      "macro": "belongs_to",
      "resource_name": "Locale",
      "through": null
    },
    {
      "className": "StripeTaxRate",
      "collectionName": "stripe_tax_rates",
      "foreignKey": "stripe_tax_rate_id",
      "name": "stripe_tax_rate",
      "macro": "belongs_to",
      "resource_name": "StripeTaxRate",
      "through": null
    }
  ],
  "paramKey": "country",
  "primaryKey": "id"
}

/** Frontend model for Country. */
export default class Country extends BaseModel {
  /** @returns {typeof modelClassData} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  countryCode() {
    return this.readAttributeUnderscore("country_code")
  }

  /** @returns {boolean} */
  hasCountryCode() {
    const value = this.countryCode()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  defaultCurrencyId() {
    return this.readAttributeUnderscore("default_currency_id")
  }

  /** @returns {boolean} */
  hasDefaultCurrencyId() {
    const value = this.defaultCurrencyId()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  defaultLocaleId() {
    return this.readAttributeUnderscore("default_locale_id")
  }

  /** @returns {boolean} */
  hasDefaultLocaleId() {
    const value = this.defaultLocaleId()

    return this._isPresent(value)
  }

  /** @returns {Date | null} */
  firstSchoolDate() {
    return this.readAttributeUnderscore("first_school_date")
  }

  /** @returns {boolean} */
  hasFirstSchoolDate() {
    const value = this.firstSchoolDate()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any | null} */
  stripeTaxRateId() {
    return this.readAttributeUnderscore("stripe_tax_rate_id")
  }

  /** @returns {boolean} */
  hasStripeTaxRateId() {
    const value = this.stripeTaxRateId()

    return this._isPresent(value)
  }

  /** @returns {Date} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {string | null} */
  name() {
    return this.readAttributeUnderscore("name")
  }

  /** @returns {boolean} */
  hasName() {
    const value = this.name()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameDa() {
    return this.readAttributeUnderscore("name_da")
  }

  /** @returns {boolean} */
  hasNameDa() {
    const value = this.nameDa()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameEn() {
    return this.readAttributeUnderscore("name_en")
  }

  /** @returns {boolean} */
  hasNameEn() {
    const value = this.nameEn()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameNo() {
    return this.readAttributeUnderscore("name_no")
  }

  /** @returns {boolean} */
  hasNameNo() {
    const value = this.nameNo()

    return this._isPresent(value)
  }

  /** @returns {any} */
  nameSe() {
    return this.readAttributeUnderscore("name_se")
  }

  /** @returns {boolean} */
  hasNameSe() {
    const value = this.nameSe()

    return this._isPresent(value)
  }

  /**
   * @template TCommandResponse
   * @param {Record<string, any> | HTMLFormElement | FormData} args
   * @param {Record<string, any>} [commandArgs]
   * @returns {Promise<TCommandResponse>}
   */
  static current(args, commandArgs = {}) {
    return /** @type {Promise<TCommandResponse>} */ (BaseModel._callCollectionCommand(
      {
        args,
        command: "current",
        collectionName: "countries",
        type: "collection"
      },
      commandArgs
    ))
  }

  /** @returns {import("./currency.js").default | null} */
  defaultCurrency() {
    return this._readBelongsToReflection({modelClass: Currency, reflectionName: "default_currency"})
  }

  /** @returns {Promise<import("./currency.js").default | null>} */
  loadDefaultCurrency() {
    if (!("defaultCurrencyId" in this)) throw new Error("Foreign key method wasn't defined: defaultCurrencyId")

    const id = this.defaultCurrencyId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "default_currency",
        model: this,
        modelClass: Currency
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./currency.js").default | null>} */
  ensureDefaultCurrencyLoaded() {
    return this.ensureAssociationLoaded("default_currency")
  }

  /** @returns {import("./locale.js").default | null} */
  defaultLocale() {
    return this._readBelongsToReflection({modelClass: Locale, reflectionName: "default_locale"})
  }

  /** @returns {Promise<import("./locale.js").default | null>} */
  loadDefaultLocale() {
    if (!("defaultLocaleId" in this)) throw new Error("Foreign key method wasn't defined: defaultLocaleId")

    const id = this.defaultLocaleId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "default_locale",
        model: this,
        modelClass: Locale
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./locale.js").default | null>} */
  ensureDefaultLocaleLoaded() {
    return this.ensureAssociationLoaded("default_locale")
  }

  /** @returns {import("./stripe-tax-rate.js").default | null} */
  stripeTaxRate() {
    return this._readBelongsToReflection({modelClass: StripeTaxRate, reflectionName: "stripe_tax_rate"})
  }

  /** @returns {Promise<import("./stripe-tax-rate.js").default | null>} */
  loadStripeTaxRate() {
    if (!("stripeTaxRateId" in this)) throw new Error("Foreign key method wasn't defined: stripeTaxRateId")

    const id = this.stripeTaxRateId()
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {
        reflectionName: "stripe_tax_rate",
        model: this,
        modelClass: StripeTaxRate
      },
      {ransack}
    )
  }

  /** @returns {Promise<import("./stripe-tax-rate.js").default | null>} */
  ensureStripeTaxRateLoaded() {
    return this.ensureAssociationLoaded("stripe_tax_rate")
  }
}
